export enum CreatePropertyPageTypeRoutes {
  LOCATION = 'location',
}

export enum CreateBuildingRoutes {
  BUILDING_DETAILS = 'building-details',
  BUILDING_PHOTOS = 'building-photos',
  FLOORPLAN_DETAILS = 'floorplan-details',
  FLOORPLAN_PHOTOS = 'floorplan-photos',
  // UNIT_DETAILS = 'unit-details',
  // UNIT_PHOTOS = 'unit-photos',
  PRICE = 'floorplan-price',
  REVIEW = 'building-review',
  SUCCESS = 'building-success',
  // ADD_DETAILS = 'building-add-details',
}

export enum CreateListingRoutes {
  ADD_DETAILS = 'listing-add-details',
  INSTARENT_SIGNUP = 'listing-instarent-signup',
  LISTING_DETAILS = 'listing-details',
  LISTING_PHOTOS = 'listing-photos',
  LISTING_VIDEOS = 'listing-videos',
  RENT_DETAILS = 'listing-rent-details',
  REVIEW = 'listing-review',
  SUCCESS = 'listing-success',
}
